import { random, uniq, map } from 'lodash';
/**
 * checks if the supplied value is undefined or not.
 *
 * @param {any} value The value needs to be checked.
 * @return {bool}
 */
export function isUndefined(value) {
    return value === undefined;
}

/**
 * checks if the supplied value is null or not.
 *
 * @param {any} value The value needs to be checked.
 * @return {Boolean}
 */
export function isNull(value) {
    return value === null;
}

/**
 * Check if a value is not null.
 * 
 * @param {any} value The value to check against null.
 * @return {Boolean}
 */
export function isNotNull(value) {
    return value !== null;
}

/**
 * Get the absolute value of the amount
 * 
 * @param {Number} value The value need to be converted to absoulute
 * @return {Boolean}
 */
export function abs(value) {
    return Math.abs(value);
}

/**
 * Determine of a value is negative
 * 
 * @param {Number} value
 * @return {Boolean}
 */
export function isNegative(value) {
    return value < 0;
}

/**
 * Determine if a value is a positive value
 * 
 * @param {Number} value
 * @return {Boolean}
 */
export function isPositive(value) {
    return value > 0;
}

/**
 * The function takes a value and render the absolute value
 * if it is greater than zero and render null if it is less than zero.
 * 
 * @param {Number} value The value to be rendered.
 * @return {Number | null}
 */
export function renderDebit(value) {
    if(value <= 0) return null;
    return abs(value); 
}

/**
 * Takes a value and render the absolute value if it is greater
 * than zero, else it will render null;
 * 
 * @param {Number} value 
 * @return {Number | null}
 */
export function renderCredit(value) {
    if(value >= 0) return null;
    return abs(value);
}

/**
 * Generate random number with 6
 */
export function randomSix() {
    return random(100000, 999999);
}

/**
 * Takes an array of objects and attempts to find if a key has
 * the same value across all other objects or not.
 * @param {string} key 
 * @param {array} array 
 */
export function hasMulti(key, array) {
    let count = pluckAndUniq(key, array).length;
    return count > 1;
}

/**
 * Takes and array and pluck a single value and remove all duplicates.
 * @param {string} key
 * @param {array} array
 */
export function pluckAndUniq(key, array) {
    let plucked = map(array, key);
    let unique = uniq(plucked);
    return unique;
}

/**
 * Takes and array of objects, pluck a key if it is not a multi
 * value. Remove all duplicates and eventually returns only one value.
 * @param {string} key 
 * @param {array} array 
 */
export function pluckAndUniqOne(key, array) {
    if(hasMulti(key, array) === true) throw new Error("Cannot pluck same. Array have multiple values for object key");
    return pluckAndUniq(key, array)[0];
}

export function arrayPushOrUpdateByID(list = [], items = []) {
    var existing = [...list];
    if(items.length == 0) return existing
    items.forEach(item => {
        var found = existing.find(each => {
            if(!each) return false;
            if(!item) return false;
            return each.id == item.id
        });
        if(!found) {
            existing.push(item);
        } else {    
            var index = existing.indexOf(found);
            existing[index] = item;
        }
    });
    return existing;
}